<template>
  <div class="test">
    <span>test</span>
  </div>
</template>

<script>
import {ddJugeTokenTimeOut} from '@/api/dd'
export default {
  name: 'test',
  mounted() {
    ddJugeTokenTimeOut().then(res => {
      window.console.log('res', res)
      if (res) {
        if (res.code === 0) {
          // 表示没有过期
        } else {
          // 过期了
          // 清除token, 并跳转首页
        }
      }
    })
  }
}
</script>

<style scoped lang="scss">
.test {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  span {
    font-size: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
